package com.trevorwiebe.timesheet.mileage.domain

import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.mileage.domain.model.MileageEntry
import com.trevorwiebe.timesheet.mileage.domain.model.TripType
import kotlinx.coroutines.flow.Flow
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime

interface MileageRepository {

    suspend fun queryMileageEntries(
        startDate: LocalDate,
        endDate: LocalDate,
        employeeId: String? = null,
        equipmentId: String? = null,
        tripTypes: Set<TripType> = emptySet(),
    ): Flow<TSResult>
    suspend fun getLastMileageEntryForEquipment(equipmentId: String): TSResult

    suspend fun getOdometerNeighbors(
        equipmentId: String,
        date: LocalDateTime,
        mileageValue: Long,
        excludeEntryId: String? = null,
    ): TSResult
    suspend fun getLastServiceEntryForEquipment(equipmentId: String): TSResult
    suspend fun addMileageEntry(entry: MileageEntry): TSResult
    suspend fun updateMileageEntry(entry: MileageEntry): TSResult
    suspend fun deleteMileageEntry(entryId: String): TSResult
}
